import React from 'react';

export function AlignLeftIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className={className}>
      <rect x="2" y="4" width="12" height="2" />
      <rect x="2" y="7" width="8" height="2" />
      <rect x="2" y="10" width="10" height="2" />
    </svg>
  );
}

export function AlignCenterIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className={className}>
      <rect x="2" y="4" width="12" height="2" />
      <rect x="4" y="7" width="8" height="2" />
      <rect x="3" y="10" width="10" height="2" />
    </svg>
  );
}

export function AlignRightIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className={className}>
      <rect x="2" y="4" width="12" height="2" />
      <rect x="6" y="7" width="8" height="2" />
      <rect x="4" y="10" width="10" height="2" />
    </svg>
  );
}

export function AlignTopIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className={className}>
      <rect x="4" y="2" width="2" height="12" />
      <rect x="7" y="2" width="2" height="8" />
      <rect x="10" y="2" width="2" height="10" />
    </svg>
  );
}

export function AlignMiddleIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className={className}>
      <rect x="4" y="2" width="2" height="12" />
      <rect x="7" y="4" width="2" height="8" />
      <rect x="10" y="3" width="2" height="10" />
    </svg>
  );
}

export function AlignBottomIcon({ className }) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" className={className}>
      <rect x="4" y="2" width="2" height="12" />
      <rect x="7" y="6" width="2" height="8" />
      <rect x="10" y="4" width="2" height="10" />
    </svg>
  );
}
